export default function EnsureProperEncoding(input) {
    try {
        // Decode once to see if it's already encoded
        let decodedOnce = decodeURIComponent(input);
  
        // Check if it matches the original input (to avoid unnecessary encoding)
        if (decodedOnce === input) {
            return encodeURIComponent(input);
        }
        return input; // Already properly encoded
    } catch (e) {
        // In case of an error in decoding (invalid encoding), just encode it
        return encodeURIComponent(input);
    }
}
  